//twilio token
export const TWILIO_TOKEN_REQUEST = 'TWILIO_TOKEN_REQUEST';
export const TWILIO_TOKEN_SUCCESS = 'TWILIO_TOKEN_SUCCESS';
export const TWILIO_TOKEN_FAILURE = 'TWILIO_TOKEN_FAILURE';

//twilio current convo
export const TWILIO_CURRENT_CONVO_SUCCESS = 'TWILIO_CURRENT_CONVO_SUCCESS';

//twilio participants
export const TWILIO_PARTICIPANTS_SUCCESS = 'TWILIO_PARTICIPANTS_SUCCESS';

//twilio messages
export const TWILIO_CONVERSATION_MESSAGE_FETCH = 'TWILIO_CONVERSATION_MESSAGE_FETCH';
export const TWILIO_CONVERSATION_PUSH_MESSAGES = 'TWILIO_CONVERSATION_PUSH_MESSAGES';

export const TWILIO_CONVERSATION_MESSAGE_UPDATE = 'TWILIO_CONVERSATION_MESSAGE_UPDATE';
